import { HubspotErrorCode, HubspotErrorLog } from '@/client/hubspot';
import { TFunction } from 'i18next';

const KNOWN_CODES = new Set<string>(Object.values(HubspotErrorCode));

export const describeHubspotError = (
  row: HubspotErrorLog,
  t: TFunction,
): string => {
  if (!KNOWN_CODES.has(row.code)) {
    return t('hubspotErrorLog.code.unknown', { code: row.code });
  }

  return t(`hubspotErrorLog.code.${row.code}`, {
    ...row.params,
    user: row.subjectName ?? row.params.userId,
  });
};
